module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-controlinput"
  }, [_c('div', {
    staticClass: "kiwi-controlinput-selfuser",
    class: {
      'kiwi-controlinput-selfuser--open': _vm.selfuser_open
    }
  }, [(_vm.selfuser_open && _vm.networkState === 'connected') ? _c('self-user', {
    attrs: {
      "network": _vm.buffer.getNetwork()
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "kiwi-controlinput-inner"
  }, [(_vm.currentNick) ? _c('div', {
    staticClass: "kiwi-controlinput-user",
    on: {
      "click": _vm.toggleSelfUser
    }
  }, [_c('span', {
    staticClass: "kiwi-controlinput-user-nick"
  }, [_vm._v(_vm._s(_vm.currentNick))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "kiwi-controlinput-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitForm($event)
      }
    }
  }, [(_vm.autocomplete_open) ? _c('auto-complete', {
    ref: "autocomplete",
    attrs: {
      "items": _vm.autocomplete_items,
      "filter": _vm.autocomplete_filter,
      "buffer": _vm.buffer
    },
    on: {
      "temp": _vm.onAutocompleteTemp,
      "selected": _vm.onAutocompleteSelected,
      "cancel": _vm.onAutocompleteCancel
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "kiwi-controlinput-input-wrap"
  }, [_c('irc-input', {
    ref: "input",
    staticClass: "kiwi-controlinput-input",
    attrs: {
      "wrap": "off",
      "placeholder": _vm.$t('input_placeholder')
    },
    on: {
      "keydown": function($event) {
        _vm.inputKeyDown($event)
      },
      "keyup": function($event) {
        _vm.inputKeyUp($event)
      },
      "click": _vm.closeInputTool
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    ref: "plugins",
    staticClass: "kiwi-controlinput-tools"
  }, [_c('a', {
    staticClass: "kiwi-controlinput-tool",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onToolClickTextStyle($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-adjust",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "kiwi-controlinput-tool",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onToolClickEmoji($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-smile-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _vm._l((_vm.pluginUiElements), function(el) {
    return _c('div', {
      directives: [{
        name: "rawElement",
        rawName: "v-rawElement",
        value: (el),
        expression: "el"
      }],
      staticClass: "kiwi-controlinput-tool"
    })
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "kiwi-controlinput-active-tool"
  }, [_c(_vm.active_tool, _vm._b({
    tag: "component"
  }, 'component', _vm.active_tool_props, false))], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-116befb8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ControlInput.vue
// module id = 477
// module chunks = 2